import selfCheckin from "./stores/selfCheckin";
import selfRedeem from "./stores/selfRedeem";

export default function () {

  console.log('force update 2024-07-25')
  return {
    modules: {
      selfCheckin,
      selfRedeem
    },
    state: {
      selfCheckin,
      selfRedeem
    },
  };
}
